import { request } from "./http";
import { buildListQuery } from "./query";

const catalogRequest = ({
  endpoint,
  searchProperty,
  searchProperties,
  search = "",
  page = 1,
  limit = 15,
  filters = [],
  sort = [],
}) => {
  const searchFilter = search.trim()
    ? searchProperties
      ? [
          {
            condition: "AND",
            group: searchProperties.map((property) => ({
              property,
              operator: "LIKE",
              value: search.trim(),
              condition: "OR",
            })),
          },
        ]
      : [{ property: searchProperty, operator: "LIKE", value: search.trim() }]
    : [];

  return request(
    `${endpoint}${endpoint.includes("?") ? "&" : "?"}${buildListQuery({
      page,
      limit,
      filters: [...searchFilter, ...filters],
      sort,
    })}`,
  );
};

const roleFilter = (value) => ({
  relation: "roles",
  property: "name",
  operator: "=",
  value,
  condition: "AND",
});
const listarUsuariosRol = (role, params = {}) =>
  catalogRequest({
    endpoint: "usuarios",
    searchProperty: "nombre",
    sort: [{ property: "nombre", direction: "ASC" }],
    ...params,
    filters: [...(params.filters || []), roleFilter(role)],
  });
export const listarAgentesVentas = (params = {}) =>
  listarUsuariosRol("VEND", params);
export const listarAgentesOperaciones = (params = {}) =>
  listarUsuariosRol("AOP", params);
const obtenerUsuarioRol = (id, role) =>
  request(`usuarios/${id}?${buildListQuery({ filters: [roleFilter(role)] })}`);
export const obtenerAgenteOperaciones = (id) => obtenerUsuarioRol(id, "AOP");

export const listarGruposClientes = (params = {}) =>
  catalogRequest({
    endpoint: "clientes-grupos",
    searchProperty: "descripcion",
    sort: [{ property: "descripcion", direction: "ASC" }],
    ...params,
  });

export const listarEmpresas = (params = {}) =>
  catalogRequest({
    endpoint: "empresas",
    searchProperty: "nombre",
    sort: [{ property: "nombre", direction: "ASC" }],
    ...params,
  });

export const obtenerAgenteVentas = (id) => obtenerUsuarioRol(id, "VEND");
export const obtenerGrupoCliente = (id) => request(`clientes-grupos/${id}`);
export const obtenerEmpresa = (id) => request(`empresas/${id}?perfil=all`);

export const listarMetodosPagoSat = () =>
  request("facturacion/catalogos/sat/metodos_pago");
export const listarFormasPagoSat = () =>
  request("facturacion/catalogos/sat/formas_pago");
export const listarUsosComprobantesSat = () =>
  request("facturacion/catalogos/sat/usos_comprobantes");
export const listarRegimenesFiscalesSat = () =>
  request("facturacion/catalogos/sat/regimenes_fiscales");

export const listarCatalogo = (endpoint, params = {}) =>
  catalogRequest({
    endpoint: endpoint.startsWith("facturacion/")
      ? endpoint
      : `${endpoint}?lookup=1`,
    searchProperty:
      {
        "precios-especiales": "nombre",
        "metodos-pago": "metodo_pago",
        "prod-categorias": "nombre",
        marcas: "nombre",
        "tipos-producto": "nombre",
        usuarios: "nombre",
        empresas: "nombre",
        proveedores: "nombre",
      }[endpoint] || "descripcion",
    ...(endpoint === "productos"
      ? {
          searchProperties: [
            "clave",
            "descripcion",
            "codigo_barras_venta",
            "alias_1",
            "alias_2",
          ],
        }
      : {}),
    ...params,
  });
export const obtenerCatalogo = (endpoint, id) =>
  request(`${endpoint}/${id}?lookup=1`);
